import { render, staticRenderFns } from "./PeriodPriceExcelPreview.vue?vue&type=template&id=65a42843&scoped=true"
import script from "./PeriodPriceExcelPreview.vue?vue&type=script&lang=js"
export * from "./PeriodPriceExcelPreview.vue?vue&type=script&lang=js"
import style0 from "./PeriodPriceExcelPreview.vue?vue&type=style&index=0&id=65a42843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a42843",
  null
  
)

export default component.exports